import { Card, Row, Col, Container } from "react-bootstrap"; 
import { useNavigate } from "react-router-dom";
import BackButton from "../BackButton";
import image1 from './image1.png';
import image2 from './image2.png';
import image3 from './image3.png';
import '../AdminServices/adminOverview.css';

function AdminServices() {
  const navigate = useNavigate();

  return (
    <Container fluid className="mt-4">
      <Row className="justify-content-center g-4">
        <Col xs={12} sm={10} md={6} lg={4}>
          <Card className="bg-success text-white shadow" onClick={() => navigate('/adminNewServices')}>
            <Card.Img src={image1} className="image-fixed-size" alt="Card image" />
            <Card.ImgOverlay>
              <Card.Title className="card-title">New Services</Card.Title>
              <Card.Text className="card-text">Our Opportunities</Card.Text>
            </Card.ImgOverlay>
          </Card>
        </Col>

        <Col xs={12} sm={10} md={6} lg={4}>
          <Card className="bg-warning text-white shadow" onClick={() => navigate('/adminActiveServices')}>
            <Card.Img src={image2} className="image-fixed-size" alt="Card image" />
            <Card.ImgOverlay>
              <Card.Title className="card-title">Active Services</Card.Title>
              <Card.Text className="card-text">Our Efforts make us Success</Card.Text>
            </Card.ImgOverlay>
          </Card>
        </Col>

        <Col xs={12} sm={10} md={6} lg={4}>
          <Card className="bg-info text-white shadow" onClick={() => navigate('/adminDetailServices')}>
            <Card.Img src={image3} className="image-fixed-size" alt="Card image" />
            <Card.ImgOverlay>
              <Card.Title className="card-title" style={{ color: "green" }}>
                <strong>Detailed Services</strong>
              </Card.Title>
              <Card.Text className="card-text" style={{ color: "green" }}>
                Our Achievements
              </Card.Text>
            </Card.ImgOverlay>
          </Card>
        </Col>
      </Row>

      <div className="text-center mt-4">
        <BackButton />
      </div>
    </Container>
  );
}

export default AdminServices;
